module.exports = __webpack_public_path__ + "img/ag.7e594a00.svg";